<template>
    <b-form-group
        :invalid-feedback="invalidFeedback"
        :state="state">
            <input id="event_date" type="text" class="form-control" :class="inputClass"
                ref="eventDatePretty"
                :value="datePretty"
                :state="state"
                readonly>
    </b-form-group>
</template>

<script>

var moment = require("moment");

export default {
    props: ["value", "state", "invalidFeedback"],
    mounted: function() {
        var self = this;
        $(this.$refs.eventDatePretty).datepicker({
            dateFormat: "dd.mm.yy",
            onSelect: function(date) {
                self.dateValue = self.format(date);
                self.$emit("input", self.dateValue);
            }
        });
    },
    methods: {
        format: function(date){
            return date === "" ? "" : moment(date, "DD.MM.YYYY").format("YYYY-MM-DD");
        },
        formatPretty: function(date){
                var platform = process.env.MIX_PLATFORM;
                if (platform === "openings24") {
                    return date === "" ? "" : moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
                }
                else
                {
                    return date === "" ? "" : moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
                }
        }
    },
    data: function() {
        return {
            dateValue: this.value
        }
    },
    watch: {
        value: function () {
            this.dateValue= this.value
        }
    },
    computed: {
        datePretty: function(){
            return this.formatPretty(this.dateValue);
        },
        inputClass: function(){
            if(this.state === false){
                return "invalid";
            } else {
                return "";
            }
        }
    },
    beforeDestroy: function() {
        $(this.$refs.eventDatePretty).datepicker("hide").datepicker("destroy");
    }
}
</script>